import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { AlertColor } from './alertClasses/alertClasses';

/** One icon per colour, so nothing has to read the word to know which it is. */
export const ALERT_ICONS: Record<AlertColor, LucideIcon> = {
  error: CircleAlert,
  warning: TriangleAlert,
  info: Info,
  success: CircleCheck,
};
